import { GifResult, GifsResult, PaginationOptions } from '@giphy/js-fetch-api'
import appendQuery from 'append-query'
import { getResults, API_URL, WEB_API_KEY } from '.'

const trendingUrl = `${API_URL}videos/trending`
const videoUrl = `${API_URL}videos`

export const trending = (params: PaginationOptions = {}) =>
    getResults(
        appendQuery(trendingUrl, {
            api_key: WEB_API_KEY,
            ...params,
        })
    ) as Promise<GifsResult>

export const video = (id: number) => {
    return getResults(
        appendQuery(`${videoUrl}/${id}`, {
            api_key: WEB_API_KEY,
        })
    ) as Promise<GifResult>
}
